export enum LabelPosition {
    LEFT,
    TOP
}
